import { ListViewProvider, useListView } from './core/ListViewProvider'
import { QueryRequestProvider, useQueryRequest } from './core/QueryRequestProvider'
import { QueryResponseProvider, useQueryResponse } from './core/QueryResponseProvider'
import { Table } from './Table'
import { ViewEditModal } from './ViewEditModal'
import { KTCard } from '../../../../../_metronic/helpers'
import { useNavigate, useParams } from 'react-router-dom'
import { Header } from '../../../../../_component/table/Header'
import { deleteBlog } from './core/_requests'
import { useEffect } from 'react'
import { actions } from '../../../../../const'

const List = () => {
  const {
    itemIdForUpdate,
    itemIdToView,
    selected,
    clearSelected,
    setItemIdForUpdate,
    setItemIdToView,
  } = useListView()
  const { refetch, isLoading } = useQueryResponse()
  const { updateState } = useQueryRequest()
  const param = useParams()
  useEffect(() => {
    const [action, id] = param['*'] ? param['*'].split('/') : []
    if (action === actions.create) setItemIdForUpdate(null)
    else if (action === actions.edit && id) setItemIdForUpdate(id)
    else if (action === actions.fetch && id) setItemIdToView(id)
  }, [param])

  return (
    <>
      <KTCard>
        <Header
          updateState={updateState}
          isLoading={isLoading}
          refetch={refetch}
          selected={selected}
          clearSelected={clearSelected}
          deleteAction={deleteBlog}
          fields={['status']}
          title='Blog'
        />
        <Table />
      </KTCard>
      {(itemIdForUpdate !== undefined || itemIdToView) && <ViewEditModal />}
    </>
  )
}

export const BlogsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <List />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
